import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  zConnectionStatus,
  zFunction,
  zIndustry,
  zOperatingHighlights,
  zSourceCompanyTags,
} from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

const schema = z.object({
  connection_status: zFiltersArray(zConnectionStatus),
  custom_keywords_filter: zFiltersArray(z.string()),
  filtersDialog: z
    .union([
      z.literal('industry_expertise'),
      z.literal('function_expertise'),
      z.literal('operating_highlights'),
      z.literal('connection_status'),
      z.literal('source_company_tags'),
      z.literal('custom_keywords_filter'),
    ])
    .optional()
    .catch(undefined),
  function_expertise: zFiltersArray(zFunction),
  industry_expertise: zFiltersArray(zIndustry),
  operating_highlights: zFiltersArray(zOperatingHighlights),
  source_company_tags: zFiltersArray(zSourceCompanyTags),
});

export type Schema = z.infer<typeof schema>;

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/candidates',
)({
  validateSearch: schema,
});
